import type { GetCategoryResponse } from '~/types/apis/v2/getCategory'

type ProductFilterState = {
  facetData: Record<string, FacetTree>
  selectedValues: { type: string; value: string; name: string }[]
  category: GetCategoryResponse['data']
  personalizable: boolean
  busy: boolean
}

export const useProductFilterStore = defineStore('productFilter', {
  state: (): ProductFilterState => ({
    facetData: {},
    selectedValues: [],
    category: [],
    personalizable: false,
    busy: false
  }),
  actions: {
    toggle(filter: { type: string; value: string; name: string }) {
      if (this.busy) return
      this.busy = true
      const index = this.selectedValues.findIndex(
        (item) => item.type === filter.type && item.value === filter.value
      )
      if (index > -1) {
        const newArray = [...this.selectedValues]
        newArray.splice(index, 1)
        this.selectedValues = newArray
      } else {
        this.selectedValues = [...this.selectedValues, filter]
      }
      this.busy = false
    },
    add(filter: { type: string; value: string; name: string }) {
      if (this.busy) return
      this.busy = true
      if (
        this.selectedValues.some(
          (item) => item.type === filter.type && item.value === filter.value
        )
      )
        return
      this.selectedValues = [filter]
      this.busy = false
    },
    updateCategory(category: GetCategoryResponse['data']) {
      this.category = category
    },
    updateFacetData(facetData: Record<string, FacetTree>) {
      this.facetData = facetData
    },
    togglePersonalizable() {
      this.personalizable = !this.personalizable
    },
    clear() {
      this.selectedValues = []
      this.personalizable = false
    }
  }
})
